import React from "react"
import Button from "../../../components/button/button"

const Position = ({ blok }) => (
  <div className="position gs_reveal">
    <h4 className="position__title">{blok.position}</h4>
    <div>
      <div className="position__workplace">{blok.location}</div>
      <div className="position__department">{blok.category}</div>
    </div>

    <Button
      blok={{
        Style: 'secondary',
        Label: blok.cta_text || 'View Position',
        content_target: { url: blok.apply_url },
      }}
    />
  </div>
)

export default Position
